import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import localEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { AvisoComponent } from './component/aviso/aviso.component';
import { ContendientesComponent } from './component/contendientes/contendientes.component';
import { NavbarComponent } from './component/navbar/navbar.component';
import { FooterComponent } from './component/footer/footer.component';
import { BuscadorComponent } from './component/buscador/buscador.component';
// import { FancyGridModule } from 'fancy-grid-angular';
import { RenunciasComponent } from './component/renuncias/renuncias.component';
import { LicenciasComponent } from './component/licencias/licencias.component';
import { FuncionesComponent } from './component/funciones/funciones.component';
import { NavbarDosComponent } from './component/navbar-dos/navbar-dos.component';
import { BuscadorDosComponent } from './component/buscador-dos/buscador-dos.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ComponentModule } from './component/component.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import {MatDialogModule} from '@angular/material/dialog';
import { VisorComponent } from './component/visor/visor.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

registerLocaleData(localEs);

@NgModule({
  declarations: [
    AppComponent,
    AvisoComponent,
    ContendientesComponent,
    VisorComponent,
    NavbarComponent,
    FooterComponent,
    BuscadorComponent,
    RenunciasComponent,
    LicenciasComponent,
    FuncionesComponent,
    NavbarDosComponent,
    BuscadorDosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    GraphQLModule,
    HttpClientModule,
    // FancyGridModule,
    BrowserAnimationsModule,
    ComponentModule,
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatDialogModule,
    PdfViewerModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
